export const validationConstants = Object.freeze({
  attachmentUpload: {
    maxFileSizeInMB: 10
  },
  receiptEditDialog: {
    maxCommentLength: 60
  }
});